import { render, staticRenderFns } from "./userFeedbackContactForm.vue?vue&type=template&id=dc4cb0f4&scoped=true&"
import script from "./userFeedbackContactForm.vue?vue&type=script&lang=js&"
export * from "./userFeedbackContactForm.vue?vue&type=script&lang=js&"
import style0 from "./userFeedbackContactForm.vue?vue&type=style&index=0&id=dc4cb0f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4cb0f4",
  null
  
)

export default component.exports